import { type FC, memo } from "react";
import Image from "components/Image";
import style from "./style.module.scss";
import clsx from "clsx";
import translation from "../translation";
import { useLocale } from "hooks";
import Link from "next/link";

interface IProps {
  nationalCode: string;
  degree: string;
  fullName: string;
  email: string;
  phone: string;
  image: string;
  alt: string;
  group: string;
  field: string;
  link: string;
}

const PersonCard: FC<IProps> = ({
  nationalCode,
  fullName,
  degree,
  email,
  phone,
  image,
  alt,
  group,
  field,
  link,
}) => {
  const { locale } = useLocale();
  return (
    <div
      className={clsx(
        "md:tw-flex tw-w-full tw-rounded-xl tw-bg-[#F6F7FB]",
        style.card
      )}
    >
      <div className="tw-p-2.5 md:tw-h-full md:tw-w-[248.5px]">
        <Link href={link || "#"}>
          <a className="tw-overflow-hidden tw-rounded-md tw-aspect-square tw-block">
            <Image
              src={image}
              width={248.5}
              height={248.5}
              className="tw-rounded-md tw-w-full tw-h-full tw-aspect-square tw-object-cover"
              alt={alt}
            />
          </a>
        </Link>
      </div>
      <div className="tw-p-4 tw-w-full md:tw-w-[calc(100%-170px)]">
        <Link href={link || "#"}>
          <a className="tw-mb-2.5 tw-text-base tw-font-bold tw-text-[#344456] tw-block">
            {fullName}
          </a>
        </Link>

        <p className="tw-mb-2.5 tw-text-xs xxxl:tw-text-sm tw-font-medium tw-text-[#344456]">
          <span>{translation?.[locale]?.GRADE}: </span>
          <span>{degree}</span>
        </p>
        {field && (
          <p className="tw-mb-2.5 last:tw-mb-0 tw-text-xs xxxl:tw-text-sm tw-font-medium tw-text-[#344456]">
            <span>{translation?.[locale]?.EXPERTATION}: </span>
            <span>{field}</span>
          </p>
        )}
        <p className="tw-mb-2.5 last:tw-mb-0 tw-text-xs xxxl:tw-text-sm tw-font-medium tw-text-[#344456]">
          <span>{translation?.[locale]?.EMAIL}: </span>
          <a href={`mailto:${email}`}>{email}</a>
        </p>
        {phone && false && (
          <p className="tw-mb-2.5 last:tw-mb-0 tw-text-xs xxxl:tw-text-sm tw-font-medium tw-text-[#344456]">
            <span>{translation?.[locale]?.PHONE}: </span>
            <a href={`tel:${phone}`}>{phone}</a>
          </p>
        )}
      </div>
    </div>
  );
};

export default memo(PersonCard);
